const termsHe = `CONNEXT — תנאי שימוש, כללי קהילה והסכם משתמש

עדכון אחרון: 2 בספטמבר 2026

ברוכים הבאים ל־Connext (״Connext״, ״אנחנו״ או ״השירות״).

Connext היא פלטפורמה חברתית ולהיכרויות, שנועדה לחבר בין בגירים באמצעות שיחות קול ווידאו בזמן אמת, הודעות, התאמות ושירותים נלווים.

ביצירת חשבון, בגישה לשירות או בשימוש בו, אתם מאשרים שקראתם והבנתם את תנאי השימוש וכללי הקהילה האלה (״התנאים״), ושאתם מסכימים להם. אם אינכם מסכימים, אין ליצור חשבון או להשתמש ב־Connext.

1. זכאות ודרישת גיל

Connext מיועדת אך ורק לבני 18 ומעלה.

ביצירת חשבון אתם מצהירים ומתחייבים כי:
• גילכם 18 לפחות.
• יש לכם כשירות משפטית להתקשר בהסכם הזה.
• המידע שמסרתם על עצמכם, לרבות גיל, זהות, מגדר, מיקום, תמונות ופרטי פרופיל נוספים, אמיתי ואינו מטעה במכוון.
• אינכם מתחזים לאדם אחר.
• לא הורחקתם לצמיתות בעבר בשל הפרת התנאים, אלא אם Connext אישרה במפורש את חזרתכם.

Connext רשאית לבקש אימות סביר של גיל או זהות כאשר הדבר נחוץ לבטיחות, אבטחה, מניעת הונאה או עמידה בדין. חשבון שקיים יסוד סביר להניח שהוא שייך לקטין מתחת לגיל 18 עשוי להיות מושעה או להיסגר מיד.

2. מטרת Connext

Connext מספקת טכנולוגיה שמאפשרת לגלות משתמשים אחרים ולתקשר איתם. השירות עשוי לכלול התאמות, שיחות קוליות מתוזמנות, שיחות וידאו חיות, אפקטים ופילטרים למצלמה, הודעות פרטיות, יצירת פרופיל, היסטוריית התאמות, הצעות לדייט ותכונות חברתיות או תקשורתיות נוספות.

Connext אינה מבטיחה קבלת התאמות, יצירת קשר זוגי, מפגש פנים אל פנים או חוויה או תוצאה מסוימת.

3. האחריות שלכם במפגש עם אחרים

האחריות להחלטה אם וכיצד לתקשר עם משתמש אחר, לתת בו אמון, לפגוש אותו או לקיים איתו קשר, היא שלכם בלבד. Connext אינה מבצעת בדיקת רקע מקיפה לכל משתמש ואינה יכולה להבטיח את נכונות המידע שמשתמשים מסרו.

יש להפעיל שיקול דעת סביר בשיחה עם זרים. אם בחרתם להיפגש פנים אל פנים, מומלץ מאוד להיפגש במקום ציבורי, לעדכן אדם שאתם סומכים עליו לאן אתם הולכים, לדאוג להסעה עצמאית, להימנע ממסירת מידע פיננסי או מזהה רגיש, לעזוב מיד אם אינכם חשים בטוחים ולפנות לשירותי חירום או לרשויות המתאימות כשנדרש.

Connext אינה מבטיחה את הזהות, הכוונות, ההתנהגות, ההתאמה או הבטיחות של משתמש אחר.

4. מדיניות אפס סובלנות לתוכן ולהתנהגות אסורים

Connext נועדה לאפשר תקשורת מכבדת ובטוחה בין בגירים. ההתנהגויות הבאות אסורות בהחלט.

4.1 עירום ותוכן מיני

אסור להציג, להעביר, להעלות, לבקש, לעודד או לחשוף משתמש אחר לעירום מלא או חלקי שנועד להיות מיני במפורש; איברי מין חשופים; מעשים מיניים או הדמיה שלהם; אוננות; חומר פורנוגרפי; תמונות או וידאו מיניים במפורש; התנהגות מינית לא רצויה; בקשות או הצעות מיניות לא רצויות; או כל תוכן מיני שמעורב בו, או שנראה שמעורב בו, אדם מתחת לגיל 18.

האיסור חל על פרופילים, תמונות, הודעות, שיחות קול ווידאו, שמות משתמש, תיאורים אישיים וכל חלק אחר בשירות. הופעה בעירום או התנהגות מינית אסורה בשיחה חיה עשויות להביא להפסקת השיחה מיד ולהשעיה או לחסימה לצמיתות. תוכן מיני שקשור לקטינים או חשד לניצול עשויים להיות מדווחים לרשויות המתאימות כאשר הדין מחייב או מתיר זאת.

4.2 שפה פוגענית, מעליבה או גסה

יש לתקשר בכבוד. אסורות שפה או התנהגות שנחשבות באופן סביר למאיימות, מטרידות, מפחידות, משפילות, מבזות, מטרידות מינית, מגונות או גסות באופן מתמשך, מלאות שנאה או מפלות, פגיעה ממוקדת, בריונות או עידוד אלימות או פגיעה עצמית.

Connext רשאית, לפי שיקול דעת סביר, להבחין בין ביטויים בוגרים מזדמנים לבין התעללות. עם זאת, הפניית שפה גסה, משפילה, מאיימת, מפלה או מינית במפורש כלפי משתמש אחר אסורה. יש לכבד בקשה של אדם להפסיק שיחה או התנהגות מסוימת.

4.3 סמים וחומרים לא חוקיים

אסור להשתמש ב־Connext כדי לקנות או למכור סמים לא חוקיים; להציע, להפיץ, לפרסם או לאפשר גישה לסמים לא חוקיים או לחומרים מפוקחים; לעודד אדם אחר לצרוך סמים לא חוקיים; לתאם עסקאות סמים; לקדם שימוש מסוכן בסמים; או להציג או לבצע צריכת סמים לא חוקית במהלך מפגש חי בשירות, כאשר הדבר מפר את הדין החל או יוצר סביבה לא בטוחה או לא הולמת.

Connext רשאית להשעות או לסגור חשבונות שמעורבים בפעילות סמים לא חוקית, ולשתף פעולה עם בקשות חוקיות של הרשויות כאשר הדין מחייב זאת.

4.4 אלימות והתנהגות מסוכנת

אסור לאיים באלימות, לעודד אלימות כלפי אדם אחר, להציג אלימות גרפית כדי לאיים או להטריד, לארגן פעילות פלילית, לעודד מעשים מסוכנים העלולים לגרום לפציעה חמורה, או לאיים בנשק או באמצעי פגיעה אחרים.

4.5 שנאה ואפליה

אסור לתקוף, לאיים, להשפיל או לעודד שנאה או אלימות על בסיס גזע, מוצא אתני, לאום, דת, מין, מגדר, נטייה מינית, מוגבלות או מאפיין אחר שמוגן בדין. העדפות היכרות כשלעצמן אינן הטרדה, כל עוד הן מבוטאות ומיושמות בכבוד ובהתאם לחוק.

4.6 הטרדה ומעקב

אסור ליצור קשר שוב ושוב עם מי שביקש בבירור להפסיק, לעקוב אחר משתמש, לנסות לאתר אותו ללא הסכמה, לאיים בחשיפת מידע פרטי, לסחוט, ליצור חשבונות נוספים כדי לעקוף חסימה או לעודד אחרים להטריד משתמש.

5. הסכמה בשיחות קול ווידאו

השתתפות בהתאמה אינה הסכמה לפעילות מינית, לתוכן מיני, להקלטה, לפרסום או לכל קשר עתידי. יש לכבד הסכמה בכל עת. כל משתתף רשאי להפסיק לתקשר עם משתמש אחר. אסור ללחוץ על אדם לחשוף מידע אישי, להשתתף בהתנהגות מינית, לעבור לפלטפורמה אחרת או להיפגש פנים אל פנים.

6. הקלטות וצילומי מסך

יש לכבד את פרטיות המשתתפים האחרים. אלא אם הדין החל מתיר זאת בבירור וניתנה כל הסכמה שנדרשת בדין, אסור להקליט, לצלם, לשכפל, לפרסם, להפיץ או לנצל מסחרית בסתר תקשורת קולית או חזותית פרטית של משתמש אחר.

עם זאת, Connext אינה יכולה להבטיח מבחינה טכנית שאדם אחר לא ישתמש בתוכנה חיצונית, במכשיר אחר או באמצעי אחר כדי להקליט תקשורת. לכן יש להימנע מחשיפת מידע או מהתנהגות במהלך שיחה שלא הייתם רוצים שאדם אחר יחזיק בתיעוד שלהם.

7. פרופילים מזויפים, התחזות ומצג שווא

אסור להתחזות לאדם אחר, להשתמש בתמונותיו ללא רשות, למסור גיל או זהות שגויים בכוונה, להפעיל חשבונות הונאה, להציג מצג שווא לצורך רווח כספי, להשתמש בבוטים או בחשבונות אוטומטיים ללא אישור Connext, או ליצור חשבונות לצורך הונאות, דיוג, שידול או פעילות מטעה. תמונות פרופיל חייבות להיות של המשתמש או תוכן שיש לו זכות חוקית להשתמש בו.

8. הונאות פיננסיות ופניות מסחריות

אסור להשתמש בשירות כדי לבקש כסף במרמה; לבצע הונאות השקעה, קריפטו, רומנטיקה או הונאות פיננסיות; לבקש סיסמאות, קודי אימות, פרטי בנק או כרטיסי תשלום; לקדם תוכניות פירמידה; לבצע פניות מסחריות ללא אישור; או לעסוק בדיוג או בגניבת זהות. אין להעביר כסף לאדם רק משום שהכרתם אותו דרך Connext.

9. זנות, שירותי מין וניצול

אסור להשתמש ב־Connext כדי לפרסם, לרכוש, למכור, לשדל או לאפשר זנות, שירותי מין בתשלום, ניצול מיני, סחר בבני אדם או פעילות לא חוקית דומה.

10. תוכן משתמשים

״תוכן משתמשים״ כולל מידע או חומר שנמסר, מועבר או מוצג בשירות, לרבות פרטי פרופיל, תמונות, תיאורים אישיים, תחומי עניין, הודעות וחומרים אחרים. הבעלות בתוכן שלכם נשארת שלכם.

במסירת תוכן אתם מעניקים ל־Connext רישיון מוגבל ולא בלעדי לארח, לשמור, לעבד, לשכפל, להציג ולהעביר אותו רק ככל שנדרש באופן סביר כדי להפעיל, לאבטח, לשפר ולספק את השירות, בכפוף לדיני הפרטיות ולמדיניות הפרטיות שלנו. אתם מצהירים שיש לכם את הזכויות הדרושות למסירת התוכן.

11. דיווח וחסימה

מומלץ לדווח על התנהגות שמפרה את התנאים או מעוררת חשש לבטיחות. Connext עשויה לספק כלי דיווח, חסימה, ניהול תוכן ובטיחות חשבון. אסור להגיש דיווחים כוזבים ביודעין, לתאם דיווחים זדוניים נגד אדם או לנצל לרעה את מערכות הדיווח.

12. אכיפה

Connext רשאית לבדוק חשדות להפרות. בהתאם לנסיבות, היא רשאית להזהיר, לסיים התאמה או שיחה פעילה, להסיר תוכן, להגביל תכונות, להשעות חשבון זמנית, לחסום לצמיתות, למנוע יצירת חשבונות חלופיים, לשמר רשומות רלוונטיות כשנדרש באופן סביר לבטיחות, למחלוקות או לעמידה בדין, ולשתף פעולה עם בקשות חוקיות של הרשויות.

הפרות חמורות, לרבות ניצול מיני, איומי אלימות, הונאה, סחר לא חוקי בסמים או התנהגות שקשורה לקטינים, עשויות להביא להרחקה מיידית לצמיתות ללא אזהרה. באכיפה ניתן להביא בחשבון הקשר, חומרה, הפרות קודמות, ראיות, בטיחות משתמשים והדין החל.

13. פרטיות ומידע אישי

Connext מעבדת מידע אישי שנדרש להפעלת השירות. בהתאם לתכונות שבהן משתמשים, המידע עשוי לכלול פרטי חשבון ופרופיל, דוא״ל או מספר טלפון, גיל, מגדר והעדפות היכרות, תמונות פרופיל, יישוב ומידע הקשור למיקום, תחומי עניין ותיאור אישי, פרטי התאמות, הודעות, הצעות לדייט, מידע טכני כגון כתובת IP, פרטי מכשיר, יומנים ואירועי אבטחה, מידע לצורך אימות ומידע שנדרש למניעת הונאות, לניהול תוכן, לאבטחה ולתמיכה.

המידע יעובד בהתאם למדיניות הפרטיות ולדיני הפרטיות והגנת המידע החלים. יש לעיין במדיניות הפרטיות לפני יצירת חשבון.

14. קול ווידאו חיים

Connext מאפשרת תקשורת חיה בין משתמשים. אלא אם תכונה מסוימת מציינת אחרת במפורש, Connext אינה מצהירה ששיחות חיות מוקלטות באופן שגרתי או נשמרות לצמיתות על ידה.

ניתן לעבד נתונים טכניים על שיחה כאשר הדבר נחוץ באופן סביר ליצירת חיבורים, לפתרון תקלות, למניעת ניצול לרעה, לשיפור האמינות או להגנה על השירות. Connext רשאית להשתמש בספקי תשתית חיצוניים להעברת התקשורת או לאפשורה.

15. מידע על מיקום

Connext עשויה להשתמש במידע הקשור למיקום לצורך התאמות ותכונות אחרות התלויות במיקום. רמת הדיוק של המיקום שנאסף או מעובד עשויה להשתנות לפי התכונה וההרשאות שנתן המשתמש. אסור להשתמש במידע מיקום שהושג דרך השירות לצורך מעקב, הטרדה, איתור או סיכון אדם אחר.

16. אבטחה

המשתמשים אחראים לסודיות ולאבטחה של חשבונותיהם. יש להודיע ל־Connext בהקדם אם אתם סבורים שמישהו ניגש לחשבון ללא אישור.

אסור לנסות לגשת לחשבון של אחר, לבדוק או לנצל חולשות אבטחה, לעקוף אימות או בקרות אבטחה, לבצע הנדסה לאחור כאשר החוק אוסר זאת, להחדיר נוזקה, להפריע לתשתית, לאסוף מידע על משתמשים באופן אוטומטי ללא אישור, לתקוף, להעמיס או לשבש את המערכות.

שום שירות אינטרנט אינו יכול להבטיח אבטחה מוחלטת. Connext תשתמש באמצעים טכניים וארגוניים סבירים המתאימים לשירות ולדרישות הדין.

17. שירותי צד שלישי

Connext עשויה להסתמך על צדדים שלישיים לצורכי אירוח, בסיסי נתונים, אימות, אחסון, תקשורת, ניתוח נתונים, מפות, תשלומים ותשתיות אחרות. ספקים אלה עשויים לעבד מידע ככל שנדרש למתן שירותיהם ובכפוף להסכמים ולדרישות הדין. Connext אינה אחראית לשירותים חיצוניים עצמאיים שמשתמשים בוחרים לגשת אליהם מחוץ לפלטפורמה.

18. מפגשים פנים אל פנים

Connext מאפשרת היכרות ואינה מפקחת על מפגשים פנים אל פנים. ההחלטה להיפגש מחוץ לרשת מתקבלת באופן עצמאי ולפי שיקול דעת המשתתפים. המשתמשים אחראים לנקיטת אמצעי זהירות אישיים סבירים. אין בתנאים כדי לשלול אחריות שלא ניתן לשלול על פי הדין החל.

19. זמינות ושינויים בשירות

Connext היא שירות מתפתח. ניתן להוסיף תכונות, לשנות אותן, להשביתן זמנית או להפסיקן. אין הבטחה לזמינות רציפה או להצלחת כל ניסיון תקשורת, התאמה, הודעה או שיחת קול או וידאו. תחזוקה, חיבור לאינטרנט, שירותים חיצוניים, מגבלות מכשיר, תנאי רשת, אירועי אבטחה ונסיבות אחרות עשויים להשפיע על הזמינות.

20. קניין רוחני

למעט תוכן משתמשים וחומרי צד שלישי, Connext והתוכנה, המיתוג, העיצובים, הממשקים, הסמלים והתוכן המקורי שלה נמצאים בבעלות Connext או בשימושה ברישיון ומוגנים בדיני הקניין הרוחני. התנאים אינם מעבירים למשתמשים בעלות בקניין הרוחני של Connext.

21. סיום החשבון ביוזמת המשתמש

אפשר להפסיק להשתמש בשירות בכל עת. כאשר קיימת אפשרות למחיקת חשבון, ניתן לבקש מחיקה דרך תהליך החשבון או התמיכה הזמין. מידע מסוים עשוי להישמר לאחר המחיקה כאשר הדבר נחוץ באופן סביר או נדרש בדין, לרבות למניעת הונאה, אבטחה, יישוב מחלוקות, אכיפת התנאים או מילוי חובות חוקיות, בכפוף לדין החל.

22. הבהרת אחריות

Connext מספקת פלטפורמה לתקשורת בין משתמשים. במידה המרבית המותרת בדין, אין היא מבטיחה את זהותו או יושרו של משתמש אחר, התאמה בין משתמשים, התנהגות ראויה, יצירת זוגיות או דייט, זמינות רציפה או תקשורת ללא הפרעות או שגיאות. אין בתנאים הגבלה על זכויות או סעדים שלא ניתן לוותר עליהם כדין.

23. הגבלת אחריות

במידה המרבית המותרת בדין, Connext, בעליה, עובדיה, קבלניה וספקי השירות שלה לא יישאו באחריות לנזקים עקיפים, מקריים, תוצאתיים או מיוחדים הנובעים מהשימוש בשירות. אין בהוראה הזאת כדי לשלול או להגביל אחריות במקום שהדין אוסר זאת.

24. שינויים בתנאים

Connext רשאית לעדכן את התנאים עם התפתחות השירות או מסיבות משפטיות, אבטחתיות, תפעוליות או מוצריות. כאשר שינוי מהותי מחייב הודעה או הסכמה מחודשת על פי הדין, תימסר הודעה או תתקבל הסכמה בהתאם. מועד התחולה יוצג בתחילת התנאים.

25. הדין החל

אלא אם הדין החל מחייב אחרת, התנאים והשימוש ב־Connext כפופים לדיני מדינת ישראל. כל הוראה בנוגע לסמכות שיפוט או למקום שיפוט כפופה להוראות המחייבות של דיני הגנת הצרכן ושל כל דין חל אחר.

26. יצירת קשר

שאלות, תלונות, דיווחי בטיחות, בקשות פרטיות והודעות משפטיות ניתן לשלוח באמצעות פרטי הקשר או אפשרויות התמיכה שמספקת Connext. על Connext לקיים ערוץ נגיש לדיווחים דחופים על בטיחות ועל ניצול לרעה.

מדידה אופציונלית לשיפור השירות
הסכמה לתנאי השימוש אינה מפעילה מדידה אופציונלית. המדידה כבויה כברירת מחדל, ואפשר להפעיל או להפסיק אותה בפרופיל תחת "פרטיות ומדידה". באישור נפרד דרך הגדרה זו, נאספים אירועי שימוש, זמני המתנה, סוג מערכת ההפעלה והדפדפן ומצב חיבור השיחה. הזיהוי נעשה באמצעות מזהה דפדפן אקראי; אין מדובר במידע אנונימי לחלוטין. המדידה אינה כוללת תוכן הודעות, הקלטות שיחה, נתוני פנים או מיקום מדויק. אירועי שיחה מיועדים למחיקה לאחר 30 יום ואירועי שימוש לאחר 90 יום. ניתן להפסיק את המדידה ולבקש מחיקת הרשומות המשויכות לדפדפן דרך אותו מסך. מחיקת אחסון הדפדפן מסירה את המזהה המקומי ועלולה למנוע קישור לרשומות קודמות; אלה יימחקו לפי מדיניות השמירה. מדידה זו אינה הרשאה למכירת מידע או לאימון מודלים על תוכן השיחות.
`;

export default termsHe;
